<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @submit:custom="customSubmit">
  </AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "RentingAddProductsForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        renting_id: null,
        products: [{ product_id: null, quantity: null }],
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        product_id_options: _.orderBy(
          this.$store.getters["product/getByStatusSlug"]('product_on_sale').selectOptions("id", "name"),
          "text"
        ),
      };
    },
  },
  mounted() {
    this.form.renting_id = this.id_to_edit

    this.$store.dispatch("product/getAllForSelect");
  },
  methods: {
    customSubmit(form) {
      this.$store
        .dispatch(
          this.config.storeNamespace + "/addProducts",
          this.config.submitFormatter ? this.config.submitFormatter(this.form, this) : this.form
        )
        .then((response) => {
          this.$store
            .dispatch(config.storeNamespace + "/getItem", {
              id: this.$route.params.id,
              wait: false,
            })
          this.$root.$emit("bv::hide::modal", "add_products_form");
          this.inSaving = false;
        })
        .catch((error) => {
          this.inSaving = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RentingAddProducts/RentingAddProductsForm.vue